module.exports = __webpack_public_path__ + "img/yk.046458b2.png";